import { Tags } from "@/enum/tags";
import { Paginated } from "src/@types/paginated";
import { apiSlice } from "../http";
import { ICreateBatchStoreEmail, IUpdateStoreCanReceiveEmail } from "@/@types/store-email";

export const emailStoreInformation = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStoreEmail: builder.query<Paginated<any>, any>({
      query: (filters) => {
        const params = new URLSearchParams(
          filters as unknown as Record<string, string>
        );

        return {
          url: `/store-email?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.STORE_EMAIL],
    }),
    addStoreEmail: builder.mutation<string, ICreateBatchStoreEmail>({
      query: (storeEmail: ICreateBatchStoreEmail) => ({
        url: "/store-email/batch",
        method: "POST",
        body: storeEmail,
      }),
      invalidatesTags: [Tags.STORE_EMAIL],
    }),
    updateStoreCanReceiveEmail: builder.mutation<string, IUpdateStoreCanReceiveEmail>({
      query: (storeEmail: IUpdateStoreCanReceiveEmail) => ({
        url: "/store-email/set/can-receive-email/",
        method: "PATCH",
        body: storeEmail,
      }),
      invalidatesTags: [Tags.STORE_EMAIL],
    }),
    generateStoreEmailExcelReport: builder.query<any, any>(
      {
        query: () => ({
          url: `/store-email/generate-report`,
          method: "GET",
        }),
        providesTags: [Tags.STORE_EMAIL],
      }
    )
  }),
  overrideExisting: true,
});

export const { useGetStoreEmailQuery, useAddStoreEmailMutation, useUpdateStoreCanReceiveEmailMutation,useLazyGenerateStoreEmailExcelReportQuery } = emailStoreInformation;

export const {
  endpoints: {
    getStoreEmail: { select: selectGetStoreEmail },
  },
} = emailStoreInformation;
